/**
 * Sanitizes a string input by trimming leading/trailing whitespace
 * and removing leading/trailing single or double quotes.
 * @param value The string to sanitize.
 * @returns The sanitized string.
 */
export const sanitizeInput = (value: string): string => {
  if (typeof value !== 'string') {
    return '';
  }
  // Trim whitespace, then remove quotes from the ends
  return value.trim().replace(/^["']|["']$/g, '');
};

/**
 * Validates if a string is a valid GUID/UUID.
 * @param guid The string to validate.
 * @returns True if the string is a valid GUID, false otherwise.
 */
export const isValidGuid = (guid: string): boolean => {
  const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return guidRegex.test(guid);
};

/**
 * Validates if a string is a plausible SharePoint site URL.
 * @param url The string to validate.
 * @returns True if the string is a valid URL pointing to a sharepoint.com domain.
 */
export const isValidSharePointUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'https:' && parsedUrl.hostname.endsWith('.sharepoint.com');
  } catch (_e) {
    return false;
  }
};
